import React from "react";
import "../Industries.css";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import { Link } from "react-router-dom";

import {
    FiChevronRight,
    FiCheckCircle,
    FiShield,
    FiTrendingUp,
    FiDatabase,
    FiCreditCard,
    FiGlobe,
    FiUsers,
    FiLock,
    FiCpu
} from "react-icons/fi";


const Industries = () => {


    const industries = [

        {
            icon: <FiDatabase />,
            title: "Banking",
            text:
                "Helping banks modernize operations with secure fintech solutions, compliance management, automation, digital transformation, and scalable technology platforms."
        },

        {
            icon: <FiUsers />,
            title: "NBFC",
            text:
                "Supporting NBFCs with efficient lending technology, risk management, KYC verification, AML monitoring, and regulatory compliance solutions."
        },

        {
            icon: <FiCreditCard />,
            title: "Payment Providers",
            text:
                "Enabling payment companies with secure transaction infrastructure, payment integrations, fraud prevention, and real-time monitoring solutions."
        },

        {
            icon: <FiShield />,
            title: "Insurance",
            text:
                "Empowering insurance organizations with digital solutions for compliance, customer onboarding, automation, and secure data management."
        },

        {
            icon: <FiGlobe />,
            title: "Digital Wallets",
            text:
                "Building secure wallet ecosystems with identity verification, transaction security, API integrations, and operational monitoring."
        },

        {
            icon: <FiCpu />,
            title: "FinTech Startups",
            text:
                "Helping fintech startups scale faster with cloud-native platforms, automation, compliance support, and innovative technology solutions."
        }

    ];



    const solutions = [

        "Digital Transformation",
        "AML & KYC Compliance",
        "Payment Technology Solutions",
        "Risk Management",
        "API Integration",
        "Cloud Infrastructure"

    ];



    return (

        <>

            <Header />


            <div className="industries-page">



                {/*=====================================================
                    HERO SECTION
            =====================================================*/}


                <section className="industries-hero">


                    <div className="container">


                        <div className="industries-hero-content">


                            <span className="industries-tag">
                                INDUSTRIES WE SERVE
                            </span>



                            <h1>

                                Empowering Financial Industries
                                Through
                                <span> Secure Digital Solutions</span>

                            </h1>



                            <p>

                                Saivari Fintech provides secure, scalable, and
                                compliance-driven technology solutions for banks,
                                NBFCs, payment providers, insurance companies,
                                digital wallets, and fintech startups.

                            </p>




                            <div className="industries-buttons">


                                <a
                                    href="/contact"
                                    className="industry-primary-btn"
                                >
                                    Get Consultation
                                </a>



                                {/* <Link
                                    to="/services"
                                    className="industry-secondary-btn"
                                >
                                    Explore Services
                                </Link> */}


                            </div>


                        </div>


                    </div>


                </section>








                {/*=====================================================
                    BREADCRUMB
            =====================================================*/}


                <section className="industries-breadcrumb">


                    <div className="container">


                        <Link to="/">
                            Home
                        </Link>


                        <FiChevronRight />


                        <span>
                            Industries
                        </span>


                    </div>


                </section>









                {/*=====================================================
                    OVERVIEW
            =====================================================*/}


                <section className="industries-overview">


                    <div className="container">


                        <div className="section-heading">


                            <span className="section-tag">
                                OUR INDUSTRIES
                            </span>



                            <h2>

                                Technology Solutions For
                                <span> Financial Ecosystem</span>

                            </h2>



                            <p>

                                We work with organizations across the financial
                                sector to improve security, compliance, efficiency,
                                and customer experience through innovative fintech
                                solutions.

                            </p>


                        </div>





                        <div className="industries-grid">


                            {
                                industries.map((item, index) => (

                                    <div
                                        className="industry-card"
                                        key={index}
                                    >


                                        <div className="industry-icon">

                                            {item.icon}

                                        </div>



                                        <h3>
                                            {item.title}
                                        </h3>



                                        <p>
                                            {item.text}
                                        </p>



                                    </div>

                                ))
                            }


                        </div>


                    </div>


                </section>









                {/*=====================================================
                    INDUSTRY BENEFITS
            =====================================================*/}


                <section className="industry-benefits">


                    <div className="container">



                        <div className="benefits-grid">



                            <div className="benefit-content">


                                <span className="section-tag">
                                    HOW WE HELP
                                </span>



                                <h2>

                                    Building Secure And
                                    <span> Scalable Financial Platforms</span>

                                </h2>



                                <p>

                                    Our solutions are designed to address the
                                    unique challenges of financial organizations,
                                    helping them improve operations, reduce risks,
                                    and accelerate digital growth.

                                </p>



                                <div className="benefit-list">


                                    {
                                        solutions.map((item, index) => (

                                            <div key={index}>

                                                <FiCheckCircle />

                                                <span>
                                                    {item}
                                                </span>

                                            </div>

                                        ))
                                    }


                                </div>



                            </div>





                            <div className="benefit-dashboard">


                                <div className="dashboard-box">


                                    <FiLock />

                                    <h3>
                                        Security First
                                    </h3>

                                    <p>
                                        Protecting financial systems and customer data.
                                    </p>


                                </div>




                                <div className="dashboard-box">


                                    <FiTrendingUp />

                                    <h3>
                                        Business Growth
                                    </h3>

                                    <p>
                                        Improving efficiency through technology.
                                    </p>


                                </div>




                                <div className="dashboard-box">


                                    <FiShield />

                                    <h3>
                                        Compliance Ready
                                    </h3>

                                    <p>
                                        Supporting regulatory requirements.
                                    </p>


                                </div>




                                <div className="dashboard-box">


                                    <FiCpu />

                                    <h3>
                                        Automation
                                    </h3>

                                    <p>
                                        Smart workflows and intelligent operations.
                                    </p>


                                </div>



                            </div>


                        </div>


                    </div>


                </section>









                {/*=====================================================
                    TECHNOLOGY SECTION
            =====================================================*/}


                <section className="industry-technology">


                    <div className="container">


                        <div className="section-heading">


                            <span className="section-tag">
                                TECHNOLOGY & COMPLIANCE
                            </span>


                            <h2>

                                Designed For The Future Of
                                <span> Digital Finance</span>

                            </h2>


                        </div>



                        <div className="technology-grid">


                            <div>

                                <FiDatabase />

                                <h3>
                                    Cloud Infrastructure
                                </h3>

                                <p>
                                    Secure and scalable cloud-native platforms.
                                </p>

                            </div>




                            <div>

                                <FiShield />

                                <h3>
                                    Regulatory Security
                                </h3>

                                <p>
                                    Compliance-focused solutions for financial institutions.
                                </p>

                            </div>




                            <div>

                                <FiGlobe />

                                <h3>
                                    API Connectivity
                                </h3>

                                <p>
                                    Seamless integration with financial ecosystems.
                                </p>

                            </div>



                        </div>


                    </div>


                </section>






                {/*=====================================================
                    CTA
            =====================================================*/}


                <section className="industries-cta">


                    <div className="container">


                        <div className="cta-box">


                            <h2>

                                Ready To Transform Your
                                <span> Financial Business?</span>

                            </h2>



                            <p>

                                Partner with Saivari Fintech to build secure,
                                compliant, and future-ready financial technology
                                solutions.

                            </p>




                            <Link
                                to="/contact"
                                className="industry-primary-btn"
                            >
                                Contact Us
                            </Link>



                        </div>


                    </div>


                </section>




            </div>


            <Footer />


        </>

    );

};


export default Industries;